export { default } from "./ClientTypeInfo";
